import { render } from "./PopWidget.vue?vue&type=template&id=0aa66f84&scoped=true"
import script from "./PopWidget.vue?vue&type=script&lang=js"
export * from "./PopWidget.vue?vue&type=script&lang=js"

import "./PopWidget.vue?vue&type=style&index=0&id=0aa66f84&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa66f84"]])

export default __exports__